interface SessionUser {
  expired?: boolean;
  access_token: string;
  refresh_token?: string;
}
interface SessionClient {
  getUser(): Promise<SessionUser | null>;
  signinSilent(): Promise<SessionUser | null>;
}

// Renew through OIDC in this document, preserving React drafts and request IDs.
// Never fall back to an iframe/redirect or persist credentials to browser storage.
export function sessionTokenProvider(clientProvider: () => Promise<SessionClient>): () => Promise<string> {
  let renewal: Promise<SessionUser | null> | undefined;
  return async () => {
    const client = await clientProvider();
    let user = await client.getUser();
    if (user?.expired && user.refresh_token) {
      renewal ??= client.signinSilent().finally(() => { renewal = undefined; });
      try { user = await renewal; }
      catch { throw new Error("Staff session renewal failed. Keep this enrollment tab open; sign-in recovery is required."); }
    }
    if (!user || user.expired || !user.access_token) {
      throw new Error("Your staff session has expired. Keep this enrollment tab open; sign-in recovery is required.");
    }
    return user.access_token;
  };
}
